module.exports = __webpack_public_path__ + "img/p1-m@2x.3e3d32d4.jpg";